import { Grid } from '@material-ui/core';
import styled from 'styled-components';

const LeftBtn = styled(Grid)`
  margin-right: 10px;
`;

export { LeftBtn };
